import type {EmailAutomationSelect as EmailAutomationSelectFragment} from 'nutshell-graphql-types';

/**
 * Helper function to get all "valid" options for enters/exits stage select,
 * based on the stageId of the target starting stage.
 *
 * @param  {Object[]} stages     - Array of stage objects to filter
 * @param  {string} stageId      - Id of "target", or "starting" stage where
 *                                 this email automation is being configured
 * @return {Object[]}            - Array of "valid" stage options, including a magic value
 */
export function getValidStagesForSelect(
    stages: EmailAutomationSelectFragment[],
    stageId: string
): any[] {
    const currentStage = stages.find((stage) => stage.id === stageId);
    if (currentStage) {
        const validStages = stages.filter((stage) => {
            return stage.position >= currentStage.position;
        });

        return validStages;
    }

    // If we can't find the current stage, just return
    return stages;
}
